import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { useProfile, useAuth, useProfileAutoFill } from "hooks";
import DisplayBox from "components/DisplayBox";
import { TagComplete, TagDuration } from "components/Tags";
import { TagOptional } from "components/Tags";
import { margins } from "style";
import { MEMBER_STATUS } from "constants/index";
import { ProfileResumeAutoFill } from "components/Profile";

/**
 * CandidateProfileStatus
 *
 * @param {Boolean}  isOptional
 */
const CandidateProfileStatus = ({ isOptional, ...props }) => {
  const { profileId } = useAuth();
  const { data, isProfileComplete } = useProfile({ profileId });
  const profileStatus = data?.profile?.status;

  const {
    task,
    progress,
    creating,
    profileLoading,
    handleCreateProfileCreationAgentTask,
    handleCancelProfileCreationAgentTask,
    cancelling,
  } = useProfileAutoFill(profileId);

  return (
    <DisplayBox
      title={<FormattedMessage id="Candidate.CandidateProfileStatus.Title" />}
      subtitle={!isProfileComplete ? isOptional ? <TagOptional /> : <TagDuration text={"~10 mins"} /> : <TagComplete />}
      description={<FormattedMessage id="Candidate.CandidateProfileStatus.Description" />}
      numColumns={1}
      rowGap={0}
      marginSize={margins.normal}
      data={[data]}
      itemRenderer={() => (
        <ProfileResumeAutoFill
          task={task}
          onUpload={handleCreateProfileCreationAgentTask}
          progress={progress}
          creating={creating}
          profileLoading={profileLoading}
          disabled={profileStatus === MEMBER_STATUS.reviewing}
          handleCancelProfileCreationAgentTask={handleCancelProfileCreationAgentTask}
          cancelling={cancelling}
        />
      )}
      {...props}
    />
  );
};

CandidateProfileStatus.propTypes = {
  isOptional: PropTypes.bool,
};

export default CandidateProfileStatus;
